<template>
  <div class="tw-w-[400px]">
    <SfSearch
      v-model="searchQuery"
      :show-clear-icon="true"
      :show-search-icon="true"
      :show-result-navigation="false"
      :placeholder="I18n.t('inbox.filters.search_input.placeholder')"
      @clear="checkPageStore.clearSearchQuery"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useSfAssistantChecksPage } from '@app/application/sf-assistant-checks/stores/page'
import SfSearch from '@app/shared/vue/components/sf-search/search-input.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  initialSearch?: string
}

const props = withDefaults(defineProps<Props>(), {
  initialSearch: '',
})

const I18n = useI18n()
const checkPageStore = useSfAssistantChecksPage()
const { searchQuery } = storeToRefs(checkPageStore)
checkPageStore.receiveInitialSearchQuery(props.initialSearch)
</script>
